import { Controller } from 'stimulus'

// Rendered by the layout only while the user is still on the default time
// zone (User#time_zone_detectable?). Sends the browser's IANA zone once; the
// server maps it to a Rails zone name and saves it, so the element stops
// rendering from the next page on.
export default class extends Controller {
  connect() {
    let zone
    try {
      zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    } catch (e) {
      return
    }
    if (!zone) return

    const meta = document.querySelector('meta[name="csrf-token"]')
    fetch(this.data.get('url'), {
      method: 'PATCH',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': meta ? meta.content : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ time_zone: zone })
    }).catch(() => {})
  }
}
